import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { Link, useHistory } from 'react-router-dom'
import auth from '../utils/auth'

const MemberDropdown = ({small}) => {
  const size = small === true ? '30px' : '40px'
  const history = useHistory()

  const handleSignOut = () => {
    auth().logout()
    history.push('/login')
  }

  return (
    <React.Fragment>
      <Dropdown>
        <DropdownTrigger>
          <div
            style={{backgroundImage: "url('/images/khub_anwar.jpg')", height: size, width: size, backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
            className="bg-no-repeat bg-center rounded-full"
          />
        </DropdownTrigger>
        <DropdownContent>
          <div className="flex p-5 border-b" style={{borderColor: '#eee'}}>
            <div
              style={{backgroundImage: "url('/images/khub_anwar.jpg')", height: size, width: size, backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
              className="bg-no-repeat bg-center rounded-full mr-2"
            />
            <Link to="/dashboard/profile">
              <div>
                <p className="font-primary normal-case text-base font-bold">Anwar Mustofa</p>
                <p className="font-primary normal-case font-normal text-xs text-gray-999">{/* Verified  */}Member</p>
              </div>
            </Link>
          </div>
          <div>
            <ul className="p-5 font-primary normal-case font-normal border-b" style={{borderColor: '#eee'}}>
              <li className="mb-2">
                <Link to="/dashboard/profile">
                  My Profile
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/tickets">
                  Event Tickets (2)
                </Link>
              </li>
            </ul>
            <ul className="p-5 font-primary normal-case font-normal">
              <li className="mb-2">
                <a href="/dashboard/bookmarks">Bookmarks</a>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/settings">
                  Account Settings
                </Link>
              </li>
              <li className="mb-2">
                <p className="font-primary font-normal" onClick={handleSignOut}>Sign Out</p>
              </li>
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { MemberDropdown }